import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Divider, Modal, Typography } from '../ui';
import classes from './ModalLink.module.scss';

const ModalLink = ({ id, title, links, description }) => {
  const [show, setShow] = React.useState(false);

  const buttonLinks = React.useMemo(
    () => links.split('\n').map((link) => {
      const [href, label] = link.split('|');
      return {
        href,
        label,
      };
    }),
    [links]
  );

  React.useEffect(() => {
    const handleClickEvent = (e) => {
      e.preventDefault();
      setShow(true);
    };

    const handleGlobalEvent = (e) => {
      if (e.detail?.modalId === id) {
        setShow(true);
      }
    };

    const el = document.querySelector(`[data-modal-toggle='${id}']`);

    if (el) {
      el.addEventListener('click', handleClickEvent);
      window.addEventListener('showModalLink', handleGlobalEvent);
      return () => {
        el.removeEventListener('click', handleClickEvent);
        window.removeEventListener('showModalLink', handleGlobalEvent);
      };
    }
    window.addEventListener('showModalLink', handleGlobalEvent);
    return () => {
      window.removeEventListener('showModalLink', handleGlobalEvent);
    };
  }, [id]);

  return (
    <Modal isTabletAboveFixedSize show={show} onClose={() => setShow(false)} aria-hidden={!show} role="presentation">
      <div className={classes.root}>
        <Typography variant="heading4">{title}</Typography>
        { /* eslint-disable-next-line react/no-danger */ }
        <Typography><div dangerouslySetInnerHTML={{ __html: description }} /></Typography>
        <Divider />
        <ul className={classNames('list-unstyled', classes.list)}>
          {buttonLinks.map(({ label, href }) => (
            <li key={href}>
              <Button renderAs="a" href={href} fullwidth="all">
                {label}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export { ModalLink };

ModalLink.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  links: PropTypes.string.isRequired,
  description: PropTypes.string
};

ModalLink.defaultProps = {
  description: ''
};
